// gap 11.9.2017 - The ngSrc directive code should do the same logic for edge that it does for IE.
(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('ngSrcDirective', ngSrcDirectiveDecorator);

    var isEdgeOrIe = window.document.documentMode || /Edge\/\d./i.test(navigator.userAgent);

    ngSrcDirectiveDecorator.$inject = ['$delegate'];
    function ngSrcDirectiveDecorator($delegate) {
        var directive = $delegate[0];
        directive.compile = compile;
        return $delegate;

        function compile() {
            return function postLink(scope, element, attr) {
                attr.$observe('ngSrc', ngSrcWatchAction);

                function ngSrcWatchAction(value) {
                    if (value) {
                        attr.$set('src', value);
                        if (isEdgeOrIe)
                            element.prop('src', attr.src);
                    }
                }
            }
        }
    }
})();